import { KeyboardAwareScrollView as KeyboardAwareImport } from 'react-native-keyboard-controller';
import { KeyboardAwareScrollViewType } from './keyboardAwareExport';

export const KeyboardAwareScrollView: KeyboardAwareScrollViewType = KeyboardAwareImport;
